

function setImgheight(){
  setTimeout(function(){
    imgs = $('.boxImageMosaic').find('img');
    imgBoxes = $('.boxImageMosaic');
    heights = parseInt(imgs.height());
    imgBoxes.each(function(){
      $(this).css({height:heights});
    });
  }, 500);
}
